import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async searchMachineByString(queryparams, cancelationToken) {
            var meta = {
                clientApiMethod: 'searchMachineByString',
                input: { queryparams: queryparams }
            }
            var response = await client().get(store.state.apiRouteRoot + "machine/search", { params: queryparams, signal: cancelationToken, meta: meta })
            if (response.data) {
                response.data.forEach((m) => {
                    m.fetched = new Date();
                });
            }
            return response.data;
        },
        async getMachineListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getMachineListFromFilter', input: { filter: filter } }
            var response = await client().post(store.state.apiRouteRoot + "Machine/Filtered", filter, { signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async gatherMachineListFromSelection(selectionFilter) {
            var meta = { clientApiMethod: 'gatherMachineListFromSelection', input: { filter: selectionFilter } }
            var response = await client().post(store.state.apiRouteRoot + "Machine/GatherSelection", selectionFilter, { meta: meta })
            return response?.data;
        },

        async getMachineById(machineId) {
            var meta = { clientApiMethod: 'getMachineById', input: { machineId: machineId } }
            var response = await client().get(store.state.apiRouteRoot + "machine/" + machineId, { meta: meta })
            return response?.data;
        },

        async createMachine(machine) {
            var meta = {
                clientApiMethod: 'createMachine',
                input: { machine },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().post(store.state.apiRouteRoot + "machine", machine, { meta: meta })
            return response?.data;
        },
        async changeMachine(machine) {
            var meta = {
                clientApiMethod: 'changeMachine',
                input: { machine },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "machine", machine, { meta: meta })
            return response?.data;
        },
        async partialBulkUpdateMachines(dto) {
            var meta = {
                clientApiMethod: 'partialBulkUpdateMachines',
                input: { dto },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machines") })
            }
            var response = await client().post(`${store.state.apiRouteRoot}Machine/BulkPartialUpdate`, dto, { meta: meta })
            return response;
        },
        async changeOwnerOnMachine(machineId, customerId) {
            var meta = {
                clientApiMethod: 'changeOwnerOnMachine',
                input: { machineId: machineId, customerId: customerId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().post(store.state.apiRouteRoot + "machine/changeOwner/" + machineId, { CustomerId: customerId }, { meta: meta })
            return response?.data;
        },
        async changeOwnerAllMachines(fromId, toId) {
            var meta = {
                clientApiMethod: 'changeOwnerAllMachines',
                input: { fromId: fromId, toId: toId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().post(`${store.state.apiRouteRoot}machine/ChangeOwnerAllMachines/From/${fromId}/To/${toId}`, null, { meta: meta })
            return response?.data;
        },
        async changeModelInfoOnMachine(machineId, modelId, supplierId, assetTypeId) {
            var meta = {
                clientApiMethod: 'changeModelInfoOnMachine',
                input: { machineId: machineId, modelId: modelId, supplierId: supplierId, assetTypeId: assetTypeId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.model") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "machine/ChangeModelInfo/" + machineId, { ModelId: modelId, SupplierId: supplierId, AssetTypeId: assetTypeId }, { meta: meta })
            return response?.data;
        },

        async getMachinePerformanceById(machineId) {
            var meta = { clientApiMethod: 'getMachinePerformanceById', input: { machineId: machineId } }
            var response = await client().get(store.state.apiRouteRoot + "machine/" + machineId + "/performance", { meta: meta })
            return response?.data;
        },
        async getMachineContractsById(machineId) {
            var meta = { clientApiMethod: 'getMachineContractsById', input: { machineId: machineId } }
            var response = await client().get(store.state.apiRouteRoot + "machine/" + machineId + "/contract", { meta: meta })
            return response?.data;
        },

        async getMachineActiveById(id) {
            var meta = {
                clientApiMethod: 'getMachineActiveById',
                input: { id }
            }
            var response = await client().get(`${store.state.apiRouteRoot}Machine/${id}/GetActiveState`, { meta: meta })
            return response?.data;
        },
        async toggleMachineActiveById(id) {
            var meta = {
                clientApiMethod: 'toggleMachineActiveById',
                input: { id },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().patch(`${store.state.apiRouteRoot}Machine/${id}/ToggleActiveState`, null, { meta: meta })
            return response?.data;
        },

        async getQrUrlByMachineId(id) {
            var meta = { clientApiMethod: 'getQrUrlByMachineId', input: { id: id } }
            var response = await client().get('/api2/' + "qr/Link/" + id, { meta: meta })
            return response?.data;
        },

        async exportMachineListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'exportMachineListFromFilter', input: { filter: filter } }
            var response = await client().post(store.state.apiRouteRoot + "Statistics/ExportMachines", filter, { signal: cancelationToken, meta: meta })
            return response?.data;
        },
    }
}